/**
 * Maps a BinomFlowDraft → BinomFlowUpdateBody (the PUT /binom/flows/:id shape).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { BinomFlowUpdateBody } from '@/hooks/binom/useBinomFlow';

import type {
  BinomDraftPath,
  BinomFlowDraft,
} from './binom-flow-draft.types';
import { diffCampaignMeta } from './draft-internals';

export function draftToUpdateBody(draft: BinomFlowDraft): BinomFlowUpdateBody {
  const defaultPaths = draft.defaultPaths.map(toPath);
  const pathGroups = draft.pathGroups.map((g) => ({
    id: g.id,
    name: g.name,
    active: true,
    smartRotation: false,
    paths: g.paths.map(toPath),
  }));
  const metaPatch = diffCampaignMeta(draft);
  return {
    id: draft.id,
    name: draft.name,
    isDefault: true,
    defaultPaths,
    ...(pathGroups.length > 0 ? { pathGroups } : {}),
    ...(Object.keys(metaPatch).length > 0 ? { campaignMeta: metaPatch } : {}),
  };
}

function toPath(p: BinomDraftPath) {
  return {
    id: p.id,
    name: p.name,
    weight: p.weight,
    active: p.active,
    landers: p.landers.map((l) => ({
      id: l.id,
      name: l.name,
      weight: l.weight,
      active: l.active,
    })),
    offers: p.offers.map((o) => ({
      id: o.id,
      name: o.name,
      weight: o.weight,
      active: o.active,
    })),
  };
}
